module.exports = __webpack_public_path__ + "img/photoshop.bbedb3df.png";